import { ROUTES } from "../../routes";
import { copyTextToClipboard } from "../../utils/actions/clipboard";
import { toastSuccess } from "../../utils/toasts";

export const useInvoiceCopyShareLink = () => {
  return (invoicePublicId: string) => {
    const href = ROUTES.INVOICE_BUSSINES_VIEW.replace(":id", invoicePublicId);
    copyTextToClipboard(window.location.origin + href);
    toastSuccess("Link copied!");
    return true;
  };
};
